import React from 'react';
import { Link } from 'react-router-dom';
import { Footer } from '../components/Footer';
import { Helmet } from 'react-helmet-async';
export function PricingPage() {
  return <>
      <Helmet data-id="element-267" data-mp="4wy2igcjctbn">
        <title data-id="element-268" data-mp="4x7yckk9hup9">Pricing - Fifth Door</title>
        <meta name="description" content="Fifth Door Pricing." data-id="element-269" data-mp="4yiymaei0kbm" />
        <link rel="preconnect" href="https://fonts.googleapis.com" data-id="element-270" data-mp="9uzp3b967arv" />
        <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin="anonymous" data-id="element-271" data-mp="xldjv9j53nq5" />
        <link href="https://fonts.googleapis.com/css2?family=Bungee&family=Bricolage+Grotesque:wght@400;500;600;700&family=Instrument+Sans:wght@400;500;600;700&display=swap" rel="stylesheet" data-id="element-272" data-mp="12kq55pud4mqm" />
      </Helmet>

      <main className="w-full relative isolate overflow-x-hidden min-h-screen" style={{
      backgroundColor: '#074030'
    }} data-id="element-273" data-mp="ssu5498pumjr">
        <div className="absolute inset-0 pointer-events-none -z-10" style={{
        backgroundImage: `
              linear-gradient(to right, rgba(255, 255, 255, 0.1) 1px, transparent 1px),
              linear-gradient(to bottom, rgba(255, 255, 255, 0.1) 1px, transparent 1px)
            `,
        backgroundSize: '30px 30px',
        backgroundPosition: '0 0'
      }} data-id="element-274" data-mp="1lb7v5mnt948a" />
        <div className="absolute inset-0 pointer-events-none -z-10" style={{
        backgroundImage: 'url(https://cdn.magicpatterns.com/uploads/bonQpX7FQKEhKvnQfRNJtT/noise-background.png)',
        backgroundRepeat: 'repeat',
        backgroundSize: '200px 200px',
        opacity: 0.24
      }} data-id="element-275" data-mp="1nxhef9pvy6ij" />

        <div className="absolute top-8 left-8 z-20" data-id="element-276" data-mp="26p0i7irqholm">
          <Link to="/" className="flex items-center gap-3" data-id="element-277" data-mp="26ngz7kep0zg5">
            <img src="https://cdn.magicpatterns.com/uploads/8dB8M4GqHB66FgPhzt2tyW/Group_44.png" alt="Fifth Door Logo" className="h-8 w-auto object-contain brightness-0 invert" data-id="element-278" data-mp="hbn7nbt134c2" />
            <span className="text-white text-lg" style={{
            fontFamily: 'Bungee, sans-serif'
          }} data-id="element-279" data-mp="121hbru58425i">
              FIFTH DOOR
            </span>
          </Link>
        </div>

        <div className="relative z-10 px-6 py-20 md:py-32 max-w-4xl mx-auto" data-id="element-280" data-mp="1fz5vgynk138z">
          <h1 className="text-[50px] md:text-[74px] mb-8 text-center" style={{
          fontFamily: 'Bungee, sans-serif',
          color: 'white',
          lineHeight: '1.1'
        }} data-id="element-281" data-mp="1fx31k3ja6pyz">
            PRICING
          </h1>
          <div className="text-white/70 leading-relaxed text-lg text-center" style={{
          fontFamily: "'Instrument Sans', sans-serif"
        }} data-id="element-282" data-mp="1trm3kdvbbrgr">
            <p className="text-xl md:text-2xl text-white/80" data-id="element-283" data-mp="23quusyysmrzf">
              Fifth Door is currently{' '}
              <span className="text-white font-semibold" data-id="element-284" data-mp="28m0fxvkdg2mg">free</span> for all
              users.
            </p>
          </div>
        </div>
      </main>

      <Footer data-id="element-285" data-mp="3o6sxkiu6ifq6" />
    </>;
}